module.exports = __webpack_public_path__ + "img/img64.418c4cd8.png";